/* CC 2026-07-24: live PDP value progress bar.
   Reads the real cart total and shows distance to the free-shipping and volume
   discount thresholds. Re-reads the cart whenever anything posts to /cart/*, so
   it updates on add-to-cart without depending on a specific theme event name. */
(function () {
  'use strict';

  var SEL = '[data-cc-value-progress]';

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2))
      .replace(/\B(?=(\d{3})+(?!\d))/, ',');
  }

  function render(el, totalCents) {
    var ship = parseInt(el.getAttribute('data-ship'), 10) * 100;
    var disc = parseInt(el.getAttribute('data-disc'), 10) * 100;
    var discLabel = el.getAttribute('data-disc-label') || '5%';
    var max = Math.max(ship, disc);
    var pct = Math.max(0, Math.min(100, (totalCents / max) * 100));

    var fill = el.querySelector('[data-cc-vp-fill]');
    var msg = el.querySelector('[data-cc-vp-msg]');
    var track = el.querySelector('[data-cc-vp-track]');
    if (fill) fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', Math.round(pct));

    el.classList.toggle('is-ship-hit', totalCents >= ship);
    el.classList.toggle('is-disc-hit', totalCents >= disc);

    if (!msg) return;
    if (totalCents >= disc) {
      msg.innerHTML = 'Free shipping and ' + discLabel + ' off unlocked';
      msg.className = 'cc-vp__msg cc-vp__msg--win';
    } else if (totalCents >= ship) {
      msg.innerHTML = 'FREE shipping unlocked. Add <b>' + money(disc - totalCents) +
        '</b> for ' + discLabel + ' off';
      msg.className = 'cc-vp__msg cc-vp__msg--part';
    } else if (totalCents > 0) {
      msg.innerHTML = 'Add <b>' + money(ship - totalCents) + '</b> for FREE shipping';
      msg.className = 'cc-vp__msg';
    } else {
      msg.innerHTML = 'Spend <b>' + money(ship) + '</b> for FREE shipping, <b>' +
        money(disc) + '</b> for ' + discLabel + ' off';
      msg.className = 'cc-vp__msg';
    }
  }

  function refresh() {
    var els = document.querySelectorAll(SEL);
    if (!els.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        for (var i = 0; i < els.length; i++) render(els[i], cart.total_price || 0);
      })
      .catch(function () { /* leave the server-rendered state in place */ });
  }

  function init() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      render(els[i], parseInt(els[i].getAttribute('data-cart-total'), 10) || 0);
    }
    if (els.length) refresh();
  }

  // any cart mutation should re-read the cart
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      return _fetch.apply(this, arguments).then(function (res) {
        if (/\/cart\//.test(href)) setTimeout(refresh, 120);
        return res;
      });
    };
  }
  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart.afterCartLoad'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
